import React from "react";
import classNames from "classnames";

import VtrgVideo from "../vtrg_video/vtrg_video";

const VtrgVideoOnly = ({ info }) => {
  if (info && info.other && typeof info.other === "string") {
    info.other = JSON.parse(info.other);
  }

  let isOldProject;

  try {
    isOldProject = new Date(info.other.created_at).getFullYear() < 2023;
  } catch(e) {
    console.error(e);

    isOldProject = false;
  }

  const video = info ? info : {};

  const curStyle = {
    padding: info.other.block_padding ? info.other.block_padding : "",
    margin: info.other.margin ? info.other.margin : "0px auto 0px",
    backgroundColor: info.other.bg_color ? info.other.bg_color : "",
  };

  return (
    // <div className={classNames(isOldProject && "vtrg-video-only")} style={curStyle}>
    <div className="vtrg-video-only" style={curStyle}>
      {video.video && <VtrgVideo video={video.video} />}
    </div>
  );
};

export default VtrgVideoOnly;
